import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Highlight} from '@components/common/highlight/highlight'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {useTooltipVisible} from '@containers/hooks'
import {Sticker} from '@extensions/sticker/sticker'
import {useMyStickersStore} from '../../../my-stickers-store'
import {StickerLibrary} from '../../../my-stickers-utils'

const TwName = tw.div`
  items-center
  truncate
  text-sm-regular
  text-primary
`

export const TwTooltipText = tw.span`
  break-words
  line-clamp-3
`

export const ListItemStickerName = observer(
  ({
    stickerLibrary,
    highlight
  }: {
    stickerLibrary: StickerLibrary
    highlight?: boolean
  }) => {
    const [state] = useMyStickersStore()
    const name = Sticker.getName(stickerLibrary.sticker)
    const titleRef = useRef<HTMLSpanElement>(null)
    const tooltipVisible = useTooltipVisible(titleRef, [name])

    return (
      <Tooltip
        content={<TwTooltipText>{name}</TwTooltipText>}
        disabled={!tooltipVisible}
        offset={[0, 10]}
        placement="bottom"
      >
        <TwName ref={titleRef}>
          {highlight ? (
            <Highlight highlight={state.searchQuery} text={name} />
          ) : (
            name
          )}
        </TwName>
      </Tooltip>
    )
  }
)
